import { makeStyles } from "@material-ui/core";

export const useMechanicalRulesStepStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2, 0),
    },
    sectionHeader: {
        marginBottom: theme.spacing(3),
        '& h3': {
            fontSize: '1.5rem',
            fontWeight: 600,
            margin: 0,
            color: theme.palette.text.primary,
        },
        '& p': {
            fontSize: '0.875rem',
            margin: theme.spacing(1, 0, 0),
            color: theme.palette.text.secondary,
        },
    },
}));
